import {useQuery} from "@apollo/client";
import {
    WmsReportListResponse,
    GET_REPORT_LISTING_FOR_WMS,
    ReportFileType,
} from "../graphql/queries/getReportFileListingForWms";
import {useEffect, useState} from "react";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";

export interface ReportFileFiltersType {
    type?: number;
    name?: string;
    reportDate?: [string | null, string | null] | null;
    operatorId?: number;
    warehouseId?: number;
}

export interface ReportQueryResult {
    reportFileData: ReportFileType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useWmsReportFileQuery = (
    filters: ReportFileFiltersType,
    currentPage: number,
    pageSize: number,
    skip: boolean = false
): ReportQueryResult => {
    const [reportFileData, setReportFileData] = useState<ReportFileType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const timeRanges = {
            reportDate: formatTimeRangeToISO(filters.reportDate),
        };

        const queryFilters = {
            ...filters,
            ...timeRanges
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "createdAt",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询，当skip为true时跳过查询
    const { data, loading: queryLoading, refetch } = useQuery<WmsReportListResponse>(GET_REPORT_LISTING_FOR_WMS,
        {
            variables: buildQueryVariables(),
            skip: skip
        });

    // 当数据变化时更新状态
    useEffect(() => {
        if (data?.getReportFileListingForWms) {
            const responseData = data.getReportFileListingForWms.content || [];
            setReportFileData(responseData);
            setLoading(false);

            // GraphQL Long 类型会被序列化为字符串，需要转换
            const totalElements = parseInt(data.getReportFileListingForWms.totalElements.toString()) || 0;
            setTotal(totalElements);
        }
    }, [data]);

    return {
        reportFileData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};

